module.exports = __webpack_public_path__ + "static/media/6.26e4f167.jpg";